export default __webpack_public_path__ + "static/media/eth-logo.d50ffe94.svg";